import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import SuccessModal from "components/wizard/StatusCheckStatusModal";
import { ImportBranch } from "../config/branchApi";

const UploadBranchModal = ({ show, onClose, payload }) => {
  const dispatch = useDispatch();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const onConfirm = async () => {
    const response = await dispatch(ImportBranch(payload)).unwrap();
    if (response?.success) {
      // toast.success(response?.message_en);
      // navigate("/practitioner/practitioner-list");
      setShowSuccessModal(true);
      onClose();
      // reset();
    } else {
      toast.error(response?.message_en);
    }
  };

  return (
    <>
      <Modal show={show} centered dialogClassName="wizard-modal">
        <Modal.Body>
          <FalconCloseButton
            onClick={onClose}
            size="sm"
            className="position-absolute top-0 end-0 me-2 mt-2"
          />
          <Flex direction="column" alignItems="center" className="mb-3">
            <h6 className="fs-9 text-700">Upload Branch</h6>
            <h6 className="fs-11 text-400 text-center">
              Do you Want to Upload the Branch ?
            </h6>
          </Flex>

          <hr />
          <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
            <Button variant="danger" size="sm" onClick={onClose}>
              No
            </Button>
            <Button variant="success" size="sm" onClick={onConfirm}>
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <SuccessModal
        modal={showSuccessModal}
        setModal={setShowSuccessModal}
        title="Successfully"
        description={"Branches Uploading Successfully"}
        branch={true}
      />
    </>
  );
};

UploadBranchModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default UploadBranchModal;
